import React from "react";
import { BulkUpdateOptionalFieldsModal } from "components/BulkUpdateOptionalFieldsModal/Modal";
import { bulkUpdateBusinesses } from "actions";
import { validationSchema } from "components/BulkUpdateOptionalFieldsModal/SaleLots/ValidationSchema";
import { uniqBy } from "lodash";
import { mapBusinessValuesToInsuranceType } from "lib/insuranceRates";
import { useSelector } from "react-redux";
import {
  getBusinesses,
  getContextByModalType,
  getIsLivestockAgent,
} from "selectors";
import { ModelNames } from "components/BulkUpdateOptionalFieldsModal/util";
import { ModalTypes } from "constants/navigation";
import { BusinessFields, DeploymentBusinessFields } from "./Fields";

// "Configures" relevant fields for update - this can/will/should be extended to
// - include different fields for different sale (sub) types.
// - hoist (rootFieldOrder) some fields for some users.
// - permission hide/show relevent fields.
function useGetBulkUpdateFields() {
  const isLivestockAgent = useSelector(getIsLivestockAgent);

  if (isLivestockAgent) {
    return DeploymentBusinessFields;
  }

  return BusinessFields;
}

interface Props {
  onClose: () => void;
}

interface InitialValues {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- Insurance type from mapBusinessValuesToInsuranceType
  transitInsuranceApplicationDefault?: any;
}

export const BulkUpdateBusinessModal: React.FC<Props> = props => {
  const { onClose } = props;

  const { businessIds, aggridRef } = useSelector(
    getContextByModalType(ModalTypes.BulkUpdateBusiness),
  );

  const bulkUpdateFields = useGetBulkUpdateFields();
  const businesses = useSelector(getBusinesses);
  const uniqueInsuranceDetails = uniqBy(
    businessIds.map(id => businesses[id] as Business),
    (business: Business) =>
      `${business.hasTransitInsuranceForSales}-${business.hasTransitInsuranceForPurchases}`,
  );

  const initialValues: InitialValues = {};

  if (uniqueInsuranceDetails.length === 1) {
    const mappedTransitInsuranceValue = mapBusinessValuesToInsuranceType(
      uniqueInsuranceDetails[0],
    );
    initialValues.transitInsuranceApplicationDefault =
      mappedTransitInsuranceValue;
  }

  return (
    <BulkUpdateOptionalFieldsModal
      onClose={onClose}
      modelIds={businessIds}
      modelName={ModelNames.BUSINESS}
      bulkUpdateActionCreator={bulkUpdateBusinesses}
      fields={bulkUpdateFields}
      initialValues={initialValues}
      validationSchema={validationSchema}
      modelObjects={businesses}
      aggridRef={aggridRef}
    />
  );
};
